import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Hero.scss';

const Hero = () => {
  const navigate = useNavigate();

  return (
    <section className="hero">
      <div className="container">
        <h1>Empowering Your Business with Smart Solutions</h1>
        <p className="hero-subtitle">We deliver comprehensive GIS mapping, Geo-Spatial Data Analysis, Socio-Economic Survey, Monitoring and Evaluation of Projects, DMS services and IT-enabled solutions that transform 
          organizations and drive success.</p>
        <button 
          className="hero-btn"
          onClick={() => navigate('/services')} // Add this line
        >
          Explore Our Services
        </button>
      </div>
    </section>
  );
};

export default Hero;